// extracted by mini-css-extract-plugin
export default {"AddKey":"AddKey_AddKey__pOGUs","form":"AddKey_form__lSZD4"};